.header {
  display: flex;
  padding: 12px;
  flex-direction: column;
  gap: 8px;
  border-block-end: 1px solid var(--border-color);
}

.feedItem {
  margin: 12px;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.pageNav {
  display: flex;
  inline-size: fit-content;
  margin-inline: auto;
  margin-block-start: 16px;
  margin-block-end: 12px;
  gap: 8px;
}

.pageNav > * {
  min-inline-size: 2em;
}
